/* eslint-disable max-len */
import React from 'react';

const DownloadIcon = () => (
  <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 24.00 24.00">
    <g>
      <path
        strokeWidth="0.2"
        strokeLinejoin="round"
        d="M 4.9994,19.9981L 18.9994,19.9981L 18.9994,17.9981L 4.9994,17.9981M 18.9994,8.99807L 14.9994,8.99807L 14.9994,2.99807L 8.9994,2.99807L 8.9994,8.99807L 4.9994,8.99807L 11.9994,15.9981L 18.9994,8.99807 Z "
      ></path>
    </g>
  </svg>
);

export default DownloadIcon;
